import { ApiClient } from "./client"

let client = new ApiClient("/api/")

export default {
  async login(cb) {
    let response = await client.post("login", { name: "p.tranchant", password: "1234" })
    if (response.data.token && response.data.user) {
      cb({ accessToken: response.data.token, user: response.data.user })
    }
  },

  async userGuid(event_guid, cb) {
    let response = await client.get("eventPilotMaster/" + event_guid)
    if (response.data.user_guid_text) {
      cb(response.data.user_guid_text)
    }
  },

  getToken() {
    let client = new ApiClient("/", null, true)

    return client.get("getToken")
  },

  async getPPTSession(cb) {
    let client = new ApiClient("/PowerPointAddin/", null, true)
    let response = await client.get("session")
    cb({
      accessToken: response.data.login.token,
      user: response.data.login.user,
      event_guid: response.data.event_guid,
    })
  },
}
